// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn_invite {
    display: flex;
    width: 100%;
    max-width: 105px;
    height: 40px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    border-radius: 8px;
    background: #163873;
    color: var(--White, #fff);
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  } 
  .property_wrap {
    border-radius: 30px;
    background: #fff;
    width: 100%;
    padding: 50px;
  }
  .heading_add {
    display: flex;
    justify-content: end;
  }
  .heading_content {
    max-width: 750px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 15px;
  }
  .heading_content h3 {
    color: var(--Black, #010404);
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  section.img__container {
    min-height: 100%;
    border-right: 1px solid #e9ecef;
  }
  section.img__container h4 {
    color: var(--Black, #010404);
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  .upload_sec {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
  }


.addproperty_form label {
  color: var(--Black, #010404);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.addproperty_form label span {
  color: #fd0d0d;
}
.addproperty_form .form-control {
  border-radius: 12px;
  border: 1px solid #e9ecef !important;
  background: var(--White, #fff);
  height: 50px !important;
  color: var(--Black, #010404);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.agent_property_details {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  flex-wrap: wrap;
  border-bottom: 1px solid #e9ecef;
  padding-bottom: 15px;
}
.details_item {
  max-width: 320px;
  width: 100%;
}
.details_item label {
  color: var(--grayscale-light-text-2, #acaebe);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.details_item p {
  color: var(--Black, #010404);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.regi_agent label {
  color: var(--Black, #010404);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.agent_register {
  display: flex;
  align-items: center;
  gap: 10px;
}
.olivia_name span {
  color: var(--Black, #010404);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.olivia_name p {
  color: var(--Gray, #5c677d);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.tabel_page .card {
  border-radius: 20px;
  background: #fff;
  padding: 15px;
}
.table_block .dataTables_wrapper div.dataTables_filter {
  display: none;
}
#dataTable {
  text-align: center;
}
.table td,
.table th {
  vertical-align: baseline;
}
.table_block #dataTable_length {
  display: none;
}
tr.table_heading {
  background: #163873;
  border: 1px solid #c4c4c4;
  color: #fff;
}
.table_heading th {
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 1px;
  color: #ffffff;
}

.table_tab_sec .nav-pills {
  display: flex;
  gap: 15px;
}
.table_tab_sec .nav-pills .nav-link {
  border-radius: 0.25rem;
  background: transparent;
  color: var(--Gray-1, #808282);
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.table_tab_sec .nav-pills .nav-link.active {
  color: #163873;
  border-bottom: 1px solid #163873;
}
.table_tab_sec h3 {
  color: #163873;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 14px;
}
.profile__tab .nav-pills a {
  display: flex;
  max-width: 200px;
  width: 100%;
  height: 40px;
  padding: 0px 10px;
  align-items: center;
  color: var(--Gray, #5c677d);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.profile__tab .nav-pills .active {
  color: #163873;
  border-radius: 8px;
  background: rgba(22, 56, 115, 0.1);
}
.profile__content {
  max-width: 500px;
  width: 100%;
  padding: 0px 50px;
}
.profile__content .btn-primary {
  border-radius: 10px;
  background: #163873;
  border: 1px solid #163873;
  color: var(--White, #fff);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  min-height: 50px;
}
.pic_upload {
  margin: 20px 0px;
}
.profile__content .form-group .form-control {
  border-radius: 12px;
  border: 1px solid var(--Stroke, #e9ecef);
  background: #e9ecef;
  min-height: 50px;
}
.profile__content .form-group label {
  color: var(--Black, #010404);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.table_top_sec {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.table_handle {
  display: flex;
  align-items: center;
  gap: 10px;
}
.table_input_block {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
}

.search_table {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-direction: row;
}
.search_table .form-control {
  border-radius: 10px !important;
  border: 1px solid #e5e6e7 !important;
  background: #fff;
  padding-left: 35px;
  min-width: 270px;
  width: 100%;
  min-height: 40px;
  color: #b8b8b8;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.search_table svg {
  position: absolute;
  left: 10px;
}

.btns_sec {
  display: flex;
  gap: 10px;
  align-items: center;
}
.btns_sec label {
  color: var(--Black, #010404);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  min-width: 50px;
}

select.form-select {
  padding: 7px;
  border-radius: 10px;
  /* border: 1px solid var(--Stroke, #e5e6e7);
  background: var(--White, #fff);
  color: var(--Black, #010404);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal; */
}
.select__box_block .form-select {
  border-radius: 10px;
  border: 1px solid var(--Stroke, #e9ecef);
  background: var(--White, #fff);
  min-height: 40px;
  padding: 10px;
}
.name_account .form-label {
  color: var(--White, #fff);
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.work__order__request_wrap ul li {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #e9ecef;
  padding-bottom: 10px;
  margin-bottom: 15px;
  flex-wrap: wrap;
}

.social__icons {
  gap: 5px;
}

.btn_order .btn-primary {
  display: flex;
  width: 120px;
  height: 40px;
  justify-content: center;
  align-items: center;
  gap: 20px;
  border-radius: 8px;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  background: #163873;
  border: 1px solid #163873;
}

.btn_approved {
  width: 70px;
  height: 24px;
  border-radius: 30px;
  background: rgba(56, 176, 0, 0.1);
  color: #38b000;
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.btn_reserved {
  width: 70px;
  height: 24px;
  border-radius: 30px;
  background: rgba(253, 13, 13, 0.1);
  color: #fd0d0d;
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.side_agent {
  margin: 30px 0px;
  border-radius: 20px;
  background: #fff;
  padding: 0px 10px;
  min-height: 100%;
}
.agent_search {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  gap: 15px;
  height: 50px;
  border-bottom: 1px solid #e5e6e7;
  padding: 40px 0px;
}
.btn_agent {
  background: #eef5f7;
  padding: 10px 12px;
}
.agent_category .btn_primary {
  height: 35px;
  width: 100%;
  color: var(--Gray-1, #808282);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  background-color: transparent;
  justify-content: left;
  padding: 10px 5px;
}
.agent_category {
  display: flex;
  align-items: center;
  gap: 15px;
}
.agent_category .dropdown {
  width: 100%;
}
.agent_category .dropdown-menu.show {
  display: block;
  width: 100%;
}
.agent_item_list {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 10px;
}
.active_agent {
  border-radius: 12px;
  background: rgba(129, 217, 247, 0.25);
}
.agent_name {
  display: flex;
  align-items: baseline;
  flex-direction: column;
  gap: 5px;
}
.agent_name h5 {
  color: var(--Black, #010404);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.agent_name p {
  color: var(--Gray-1, #808282);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.agent_mode p {
  margin: 0;
  color: var(--Gray-1, #808282);
  font-size: 8px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.agent_chatbot {
  margin: 30px 0px;
}
.tabel_page .agent_chat {
  margin-top: 0px;
}
/* fix QA bugs manage  dimention of chat_header */
.chat_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 20px;
  background: var(--grayscale-white, #fff);
  padding: 20px;
  gap: 10px;
  width:100%;
}
.user_chat{
  max-height: 80px !important;
  min-width: 728px !important;
  }
.agent_logo {
  display: flex;
  align-items: center;
  gap: 15px;
}
.chat_agent h5 {
  color: var(--Black, #010404);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.chat_agent p {
  color: var(--Gray-1, #808282);
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 0;
}
.chat_bedroom h3 {
  color: var(--Black, #010404);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.chat_bedroom p {
  color: var(--Gray-1, #808282);
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-top: 5px;
}
.chat_bedroom p a {
  color: var(--Primary, #549cac);
}
#dataTable_wrapper .dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  color: var(--Black, #010404);
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  gap: 10px;
}

.span-card-agent {
  color:  #549CAC !important;
  font-size: 32px;
  font-weight: 700;
  line-height: 38px;
  letter-spacing: 0em;
  text-align: left;
}

.hide-link {
  color: #808282 !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  line-height: 19px !important;
  letter-spacing: 0px !important;
  text-align: center !important;
}

.save_changes_btn {
  display: flex;
  width: 120px ;
  height: 40px;
  justify-content: center;
  align-items: center;
  gap: 20px;
  border-radius: 8px;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  background: #163873;
  border: 1px solid #163873;
  color: #ffffff;
}

/* --------------------------------------------- */
/* ---- Super Admin:Wallet Page  Css ---- */
/* -------------------------------------------- */

.tocken_card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 303px;
  width: 100%;
  height: 112px;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0px 14px 24px 0px rgba(22, 56, 115, 0.04);
  padding: 0px 20px;
}
.tocken_content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.tocken_content p {
  color: var(--Black, #010404);
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.tocken_content h3 {
  color: #163873;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.tocken_block {
  display: flex;
  gap: 20px;
  align-items: normal;
}
.buy_more {
  display: flex;
  width: 112px;
  height: 112px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 16px;
  border: 1px solid #000;
  background: rgba(22, 56, 115, 0.1);
  color: #163873;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.history_sec {
  padding: 15px 0px;
}
.history_block {
  padding: 15px 0px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}
.history_card {
  width: 100%;
  height: 88px;
  border-radius: 16px;
  border: 2px solid var(--Stroke, #e9ecef);
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 20px;
}
.h-box-1 h5 {
  color: var(--Black, #010404);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.h-box-1 p {
  color: var(--Black, #010404);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.h-box-1 {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.h-box-1 h3 {
  color: #38b000;
  text-align: right;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.h-box-1 .red {
  color: #fd0d0d;
}
.select_only {
  display: flex;
  flex-direction: column;
}

.request_order {
  max-width: unset !important;
  margin: auto;
  text-align: center;
  justify-content: center;
}
.work_order_list {
  max-width: 300px;
  width: 100%;
}

.work__order__request_wrap ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.work_order_list .form-label {
  color: var(--grayscale-light-text-2, #acaebe);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.work_order_list .form-control {
  color: var(--Black, #010404);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  padding: 0;
}

.updates_order .form-control {
  padding: 10px;
  border-radius: 12px;
  border: 1px solid var(--Stroke, #e9ecef) !important;
  background: var(--White, #fff);
  min-height: 50px;
  min-width: 620px;
}
.btn_order {
  gap: 10px;
}
.btn_order .btn-secondary {
  display: flex;
  width: 120px;
  height: 40px;
  justify-content: center;
  align-items: center;
  gap: 20px;
  border-radius: 8px;
  border: 1px solid #fd0d0d;
  color: #fd0d0d;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  background: none;
}

.property_details{
  color:#010404 !important;
}
.btn_pending_customer_a{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 70px;
  height: 24px;
  border-radius: 30px;
  background: rgba(255, 122, 0, 0.1);
  color: #ff7a00;
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-size: 12px !important;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  border: none;
}

.btn_accept_customer_a{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 24px;
  border-radius: 30px;
  background: #38b0001a;
  color: #38b000;
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-size: 12px !important;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  border: none;
}
/* add some css make for responsive seema */
@media only screen and (min-width: 310px) and (max-width: 1023px) {
  .updates_order .form-control  {
   min-width: 0;
  }
}
@media only screen and (min-width: 310px) and (max-width: 991px) {
  /* .active_header {
    display: none !important;
  } */
}
@media only screen and (min-width: 310px) and (max-width:525px) {
  .search_table{
flex-direction: column;
  }
}
@media only screen and (min-width: 800px) and (max-width: 1024px) {
  .new_prop  svg {
    left:91px
  }
}
@media only screen and (min-width: 768px) and (max-width:990px) {
  .new_prop  svg {
    left:45px;
    margin-top: 2px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/agentpanel/styles/agent-style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,aAAa;EACf;EACA;IACE,aAAa;IACb,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,SAAS;EACX;EACA;IACE,4BAA4B;IAC5B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAC5B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,SAAS;IACT,eAAe;EACjB;;;AAGF;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,8BAA8B;EAC9B,uBAAuB;EACvB,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,6CAA6C;EAC7C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,kCAAkC;AACpC;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB;;;;;;wBAMsB;AACxB;AACA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iCAAiC;EACjC,cAAc;EACd,kBAAkB;EAClB,6CAA6C;EAC7C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,6CAA6C;EAC7C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;EAC9B,SAAS;EACT,YAAY;EACZ,gCAAgC;EAChC,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,WAAW;EACX,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA,iDAAiD;AACjD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,SAAS;EACT,UAAU;AACZ;AACA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B;AACF;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS;EACT,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,kDAAkD;AAClD,2CAA2C;AAC3C,iDAAiD;;AAEjD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,qDAAqD;EACrD,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,sBAAsB;EACtB,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,6CAA6C;EAC7C,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mDAAmD;EACnD,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,6CAA6C;EAC7C,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,6CAA6C;EAC7C,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;AACA,2CAA2C;AAC3C;EACE;GACC,YAAY;EACb;AACF;AACA;EACE;;KAEG;AACL;AACA;EACE;AACF,sBAAsB;EACpB;AACF;AACA;EACE;IACE;EACF;AACF;AACA;EACE;IACE,SAAS;IACT,0BAA0B;EAC5B;AACF","sourcesContent":[".btn_invite {\n    display: flex;\n    width: 100%;\n    max-width: 105px;\n    height: 40px;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    border-radius: 8px;\n    background: #163873;\n    color: var(--White, #fff);\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n  } \n  .property_wrap {\n    border-radius: 30px;\n    background: #fff;\n    width: 100%;\n    padding: 50px;\n  }\n  .heading_add {\n    display: flex;\n    justify-content: end;\n  }\n  .heading_content {\n    max-width: 750px;\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 15px;\n  }\n  .heading_content h3 {\n    color: var(--Black, #010404);\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n  }\n  section.img__container {\n    min-height: 100%;\n    border-right: 1px solid #e9ecef;\n  }\n  section.img__container h4 {\n    color: var(--Black, #010404);\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n  }\n  .upload_sec {\n    display: flex;\n    gap: 20px;\n    flex-wrap: wrap;\n  }\n\n\n.addproperty_form label {\n  color: var(--Black, #010404);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.addproperty_form label span {\n  color: #fd0d0d;\n}\n.addproperty_form .form-control {\n  border-radius: 12px;\n  border: 1px solid #e9ecef !important;\n  background: var(--White, #fff);\n  height: 50px !important;\n  color: var(--Black, #010404);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.agent_property_details {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n  flex-wrap: wrap;\n  border-bottom: 1px solid #e9ecef;\n  padding-bottom: 15px;\n}\n.details_item {\n  max-width: 320px;\n  width: 100%;\n}\n.details_item label {\n  color: var(--grayscale-light-text-2, #acaebe);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.details_item p {\n  color: var(--Black, #010404);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.regi_agent label {\n  color: var(--Black, #010404);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.agent_register {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.olivia_name span {\n  color: var(--Black, #010404);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.olivia_name p {\n  color: var(--Gray, #5c677d);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.tabel_page .card {\n  border-radius: 20px;\n  background: #fff;\n  padding: 15px;\n}\n.table_block .dataTables_wrapper div.dataTables_filter {\n  display: none;\n}\n#dataTable {\n  text-align: center;\n}\n.table td,\n.table th {\n  vertical-align: baseline;\n}\n.table_block #dataTable_length {\n  display: none;\n}\ntr.table_heading {\n  background: #163873;\n  border: 1px solid #c4c4c4;\n  color: #fff;\n}\n.table_heading th {\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 20px;\n  letter-spacing: 1px;\n  color: #ffffff;\n}\n\n.table_tab_sec .nav-pills {\n  display: flex;\n  gap: 15px;\n}\n.table_tab_sec .nav-pills .nav-link {\n  border-radius: 0.25rem;\n  background: transparent;\n  color: var(--Gray-1, #808282);\n  text-align: center;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.table_tab_sec .nav-pills .nav-link.active {\n  color: #163873;\n  border-bottom: 1px solid #163873;\n}\n.table_tab_sec h3 {\n  color: #163873;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  margin-bottom: 14px;\n}\n.profile__tab .nav-pills a {\n  display: flex;\n  max-width: 200px;\n  width: 100%;\n  height: 40px;\n  padding: 0px 10px;\n  align-items: center;\n  color: var(--Gray, #5c677d);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.profile__tab .nav-pills .active {\n  color: #163873;\n  border-radius: 8px;\n  background: rgba(22, 56, 115, 0.1);\n}\n.profile__content {\n  max-width: 500px;\n  width: 100%;\n  padding: 0px 50px;\n}\n.profile__content .btn-primary {\n  border-radius: 10px;\n  background: #163873;\n  border: 1px solid #163873;\n  color: var(--White, #fff);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  min-height: 50px;\n}\n.pic_upload {\n  margin: 20px 0px;\n}\n.profile__content .form-group .form-control {\n  border-radius: 12px;\n  border: 1px solid var(--Stroke, #e9ecef);\n  background: #e9ecef;\n  min-height: 50px;\n}\n.profile__content .form-group label {\n  color: var(--Black, #010404);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.table_top_sec {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.table_handle {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.table_input_block {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  flex-wrap: wrap;\n}\n\n.search_table {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-direction: row;\n}\n.search_table .form-control {\n  border-radius: 10px !important;\n  border: 1px solid #e5e6e7 !important;\n  background: #fff;\n  padding-left: 35px;\n  min-width: 270px;\n  width: 100%;\n  min-height: 40px;\n  color: #b8b8b8;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.search_table svg {\n  position: absolute;\n  left: 10px;\n}\n\n.btns_sec {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n.btns_sec label {\n  color: var(--Black, #010404);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px;\n  min-width: 50px;\n}\n\nselect.form-select {\n  padding: 7px;\n  border-radius: 10px;\n  /* border: 1px solid var(--Stroke, #e5e6e7);\n  background: var(--White, #fff);\n  color: var(--Black, #010404);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal; */\n}\n.select__box_block .form-select {\n  border-radius: 10px;\n  border: 1px solid var(--Stroke, #e9ecef);\n  background: var(--White, #fff);\n  min-height: 40px;\n  padding: 10px;\n}\n.name_account .form-label {\n  color: var(--White, #fff);\n  text-align: center;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.work__order__request_wrap ul li {\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 1px solid #e9ecef;\n  padding-bottom: 10px;\n  margin-bottom: 15px;\n  flex-wrap: wrap;\n}\n\n.social__icons {\n  gap: 5px;\n}\n\n.btn_order .btn-primary {\n  display: flex;\n  width: 120px;\n  height: 40px;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  background: #163873;\n  border: 1px solid #163873;\n}\n\n.btn_approved {\n  width: 70px;\n  height: 24px;\n  border-radius: 30px;\n  background: rgba(56, 176, 0, 0.1);\n  color: #38b000;\n  text-align: center;\n  font-feature-settings: \"clig\" off, \"liga\" off;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.btn_reserved {\n  width: 70px;\n  height: 24px;\n  border-radius: 30px;\n  background: rgba(253, 13, 13, 0.1);\n  color: #fd0d0d;\n  text-align: center;\n  font-feature-settings: \"clig\" off, \"liga\" off;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.side_agent {\n  margin: 30px 0px;\n  border-radius: 20px;\n  background: #fff;\n  padding: 0px 10px;\n  min-height: 100%;\n}\n.agent_search {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  justify-content: space-between;\n  gap: 15px;\n  height: 50px;\n  border-bottom: 1px solid #e5e6e7;\n  padding: 40px 0px;\n}\n.btn_agent {\n  background: #eef5f7;\n  padding: 10px 12px;\n}\n.agent_category .btn_primary {\n  height: 35px;\n  width: 100%;\n  color: var(--Gray-1, #808282);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  background-color: transparent;\n  justify-content: left;\n  padding: 10px 5px;\n}\n.agent_category {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n.agent_category .dropdown {\n  width: 100%;\n}\n.agent_category .dropdown-menu.show {\n  display: block;\n  width: 100%;\n}\n.agent_item_list {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 10px;\n}\n.active_agent {\n  border-radius: 12px;\n  background: rgba(129, 217, 247, 0.25);\n}\n.agent_name {\n  display: flex;\n  align-items: baseline;\n  flex-direction: column;\n  gap: 5px;\n}\n.agent_name h5 {\n  color: var(--Black, #010404);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n.agent_name p {\n  color: var(--Gray-1, #808282);\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.agent_mode p {\n  margin: 0;\n  color: var(--Gray-1, #808282);\n  font-size: 8px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.agent_chatbot {\n  margin: 30px 0px;\n}\n.tabel_page .agent_chat {\n  margin-top: 0px;\n}\n/* fix QA bugs manage  dimention of chat_header */\n.chat_header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: 20px;\n  background: var(--grayscale-white, #fff);\n  padding: 20px;\n  gap: 10px;\n  width:100%;\n}\n.user_chat{\n  max-height: 80px !important;\n  min-width: 728px !important;\n  }\n.agent_logo {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n.chat_agent h5 {\n  color: var(--Black, #010404);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.chat_agent p {\n  color: var(--Gray-1, #808282);\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  margin: 0;\n}\n.chat_bedroom h3 {\n  color: var(--Black, #010404);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.chat_bedroom p {\n  color: var(--Gray-1, #808282);\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  margin-top: 5px;\n}\n.chat_bedroom p a {\n  color: var(--Primary, #549cac);\n}\n#dataTable_wrapper .dropdown-item {\n  display: block;\n  width: 100%;\n  padding: 0.25rem 1.5rem;\n  clear: both;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n  color: var(--Black, #010404);\n  text-align: center;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  gap: 10px;\n}\n\n.span-card-agent {\n  color:  #549CAC !important;\n  font-size: 32px;\n  font-weight: 700;\n  line-height: 38px;\n  letter-spacing: 0em;\n  text-align: left;\n}\n\n.hide-link {\n  color: #808282 !important;\n  font-size: 16px !important;\n  font-weight: 500 !important;\n  line-height: 19px !important;\n  letter-spacing: 0px !important;\n  text-align: center !important;\n}\n\n.save_changes_btn {\n  display: flex;\n  width: 120px ;\n  height: 40px;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  background: #163873;\n  border: 1px solid #163873;\n  color: #ffffff;\n}\n\n/* --------------------------------------------- */\n/* ---- Super Admin:Wallet Page  Css ---- */\n/* -------------------------------------------- */\n\n.tocken_card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  max-width: 303px;\n  width: 100%;\n  height: 112px;\n  border-radius: 16px;\n  background: #fff;\n  box-shadow: 0px 14px 24px 0px rgba(22, 56, 115, 0.04);\n  padding: 0px 20px;\n}\n.tocken_content {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.tocken_content p {\n  color: var(--Black, #010404);\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.tocken_content h3 {\n  color: #163873;\n  font-size: 32px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.tocken_block {\n  display: flex;\n  gap: 20px;\n  align-items: normal;\n}\n.buy_more {\n  display: flex;\n  width: 112px;\n  height: 112px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-radius: 16px;\n  border: 1px solid #000;\n  background: rgba(22, 56, 115, 0.1);\n  color: #163873;\n  text-align: center;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.history_sec {\n  padding: 15px 0px;\n}\n.history_block {\n  padding: 15px 0px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n}\n.history_card {\n  width: 100%;\n  height: 88px;\n  border-radius: 16px;\n  border: 2px solid var(--Stroke, #e9ecef);\n  background: #fff;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0px 20px;\n}\n.h-box-1 h5 {\n  color: var(--Black, #010404);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.h-box-1 p {\n  color: var(--Black, #010404);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.h-box-1 {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n.h-box-1 h3 {\n  color: #38b000;\n  text-align: right;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.h-box-1 .red {\n  color: #fd0d0d;\n}\n.select_only {\n  display: flex;\n  flex-direction: column;\n}\n\n.request_order {\n  max-width: unset !important;\n  margin: auto;\n  text-align: center;\n  justify-content: center;\n}\n.work_order_list {\n  max-width: 300px;\n  width: 100%;\n}\n\n.work__order__request_wrap ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.work_order_list .form-label {\n  color: var(--grayscale-light-text-2, #acaebe);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.work_order_list .form-control {\n  color: var(--Black, #010404);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  padding: 0;\n}\n\n.updates_order .form-control {\n  padding: 10px;\n  border-radius: 12px;\n  border: 1px solid var(--Stroke, #e9ecef) !important;\n  background: var(--White, #fff);\n  min-height: 50px;\n  min-width: 620px;\n}\n.btn_order {\n  gap: 10px;\n}\n.btn_order .btn-secondary {\n  display: flex;\n  width: 120px;\n  height: 40px;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n  border-radius: 8px;\n  border: 1px solid #fd0d0d;\n  color: #fd0d0d;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  background: none;\n}\n\n.property_details{\n  color:#010404 !important;\n}\n.btn_pending_customer_a{\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 70px;\n  height: 24px;\n  border-radius: 30px;\n  background: rgba(255, 122, 0, 0.1);\n  color: #ff7a00;\n  text-align: center;\n  font-feature-settings: \"clig\" off, \"liga\" off;\n  font-size: 12px !important;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  border: none;\n}\n\n.btn_accept_customer_a{\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 60px;\n  height: 24px;\n  border-radius: 30px;\n  background: #38b0001a;\n  color: #38b000;\n  text-align: center;\n  font-feature-settings: \"clig\" off, \"liga\" off;\n  font-size: 12px !important;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  border: none;\n}\n/* add some css make for responsive seema */\n@media only screen and (min-width: 310px) and (max-width: 1023px) {\n  .updates_order .form-control  {\n   min-width: 0;\n  }\n}\n@media only screen and (min-width: 310px) and (max-width: 991px) {\n  /* .active_header {\n    display: none !important;\n  } */\n}\n@media only screen and (min-width: 310px) and (max-width:525px) {\n  .search_table{\nflex-direction: column;\n  }\n}\n@media only screen and (min-width: 800px) and (max-width: 1024px) {\n  .new_prop  svg {\n    left:91px\n  }\n}\n@media only screen and (min-width: 768px) and (max-width:990px) {\n  .new_prop  svg {\n    left:45px;\n    margin-top: 2px !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
